module.exports = __webpack_public_path__ + "img/tbzy-colour.add62d03.png";